// Простой массив из 24 шаблонов
export const templates = [
  { 
    name: 'Alpha', 
    image: 'alpha.png',
    demo: '/templates/alpha/index.html',
    zip: 'https://html5up.net/alpha/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Многоцелевой шаблон с компонентами'
  },
  { 
    name: 'Big Picture', 
    image: 'big-picture.png',
    demo: '/templates/big-picture/index.html',
    zip: 'https://html5up.net/big-picture/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Одностраничный сайт-визитка с большими фото'
  },
  { 
    name: 'Dimension', 
    image: 'dimension.png',
    demo: '/templates/dimension/index.html',
    zip: 'https://html5up.net/dimension/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Лендинг с параллакс-эффектом и модальными окнами'
  },
  { 
    name: 'Directive', 
    image: 'directive.png',
    demo: '/templates/directive/index.html',
    zip: 'https://html5up.net/directive/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Простое портфолио с иконками'
  },
  { 
    name: 'Editorial', 
    image: 'editorial.png',
    demo: '/templates/editorial/index.html',
    zip: 'https://html5up.net/editorial/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Блог с редакционным дизайном'
  },
  { 
    name: 'Escape Velocity', 
    image: 'escape-velocity.png',
    demo: '/templates/escape-velocity/index.html',
    zip: 'https://html5up.net/escape-velocity/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Динамичный сайт для творческих профессий'
  },
  { 
    name: 'Ethereal', 
    image: 'ethereal.png',
    demo: '/templates/ethereal/index.html',
    zip: 'https://html5up.net/ethereal/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Лендинг с нестандартной вёрсткой'
  },
  { 
    name: 'Forty', 
    image: 'forty.png',
    demo: '/templates/forty/index.html',
    zip: 'https://html5up.net/forty/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Портфолио с сеткой и эффектами'
  },
  { 
    name: 'Future Imperfect', 
    image: 'future-imperfect.png',
    demo: '/templates/future-imperfect/index.html',
    zip: 'https://html5up.net/future-imperfect/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Минималистичный блог с акцентом на тексте'
  },
  { 
    name: 'Helios', 
    image: 'helios.png',
    demo: '/templates/helios/index.html',
    zip: 'https://html5up.net/helios/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Креативный шаблон для спецпроектов'
  },
  { 
    name: 'Highlights', 
    image: 'highlights.png',
    demo: '/templates/highlights/index.html',
    zip: 'https://html5up.net/highlights/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Шаблон для сервиса или приложения'
  },
  { 
    name: 'Hyperspace', 
    image: 'hyperspace.png',
    demo: '/templates/hyperspace/index.html',
    zip: 'https://html5up.net/hyperspace/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Интерактивный лендинг с боковой панелью'
  },
  { 
    name: 'Landed', 
    image: 'landed.png',
    demo: '/templates/landed/index.html',
    zip: 'https://html5up.net/landed/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Корпоративный сайт с параллаксом'
  },
  { 
    name: 'Massively', 
    image: 'massively.png',
    demo: '/templates/massively/index.html',
    zip: 'https://html5up.net/massively/download',
    tech: ['HTML5', 'CSS3', 'JavaScript'],
    description: 'Мощный шаблон для технологического блога'
  },
  { 
    name: 'Multiverse', 
    image: 'multiverse.png',
    demo: '/templates/multiverse/index.html',
    zip: 'https://html5up.net/multiverse/download',
    tech: ['HTML5', 'CSS3', 'JavaScript'],
    description: 'Лендинг-портфолио с сеткой изображений'
  },
  { 
    name: 'Phantom', 
    image: 'phantom.png',
    demo: '/templates/phantom/index.html',
    zip: 'https://html5up.net/phantom/download',
    tech: ['HTML5', 'CSS Grid'],
    description: 'Креативный лендинг с сеткой проектов'
  },
  { 
    name: 'Photon', 
    image: 'photon.png',
    demo: '/templates/photon/index.html',
    zip: 'https://html5up.net/photon/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Одностраничное портфолио для фотографов'
  },
  { 
    name: 'Read Only', 
    image: 'read-only.png',
    demo: '/templates/read-only/index.html',
    zip: 'https://html5up.net/read-only/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Сайт-визитка с фиксированной боковой панелью'
  },
  { 
    name: 'Solid State', 
    image: 'solid-state.png',
    demo: '/templates/solid-state/index.html',
    zip: 'https://html5up.net/solid-state/download',
    tech: ['HTML5', 'CSS3', 'JavaScript'],
    description: 'Корпоративный шаблон с боковым меню'
  },
  { 
    name: 'Spectral', 
    image: 'spectral.png',
    demo: '/templates/spectral/index.html',
    zip: 'https://html5up.net/spectral/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Одностраничный сайт с разделённым экраном'
  },
  { 
    name: 'Stellar', 
    image: 'stellar.png',
    demo: '/templates/stellar/index.html',
    zip: 'https://html5up.net/stellar/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Портфолио с карточками проектов'
  },
  { 
    name: 'Story', 
    image: 'story.png',
    demo: '/templates/story/index.html',
    zip: 'https://html5up.net/story/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Визуальный блог с акцентом на фото'
  },
  { 
    name: 'Strata', 
    image: 'strata.png',
    demo: '/templates/strata/index.html',
    zip: 'https://html5up.net/strata/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Персональный сайт с боковой панелью'
  },
  { 
    name: 'Telephasic', 
    image: 'telephasic.png',
    demo: '/templates/telephasic/index.html',
    zip: 'https://html5up.net/telephasic/download',
    tech: ['HTML5', 'CSS3'],
    description: 'Адаптивный корпоративный шаблон'
  }
];